export default "__VITE_ASSET__BwegM8VR__"